import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import 'slick';
import 'Isotope';

export class partnerLogoFilter{
	private $scope: any = $('.partner-offer--logofilter');
	private $isotopeInstance:any;
	private $filterValue:any;

	partnerIsotope(): any{
		let _self = this;
		let $partnerElem: any        = document.querySelector('.grid.partner');
		let $partnerItemWidth:number = $partnerElem.querySelector('.partner-logo--items .logo-container').offsetWidth;
		// let $partnerItemGutter:number    = 20;

		// append grid sizer to component
		$($partnerElem).prepend('<div class="partner-logo--gutter"></div>').addClass('isotope-init');

		let $initIsotope: any = new Isotope( $partnerElem, {
			itemSelector: '.partner-logo--items',
			// layoutMode: 'fitRows',
			filter: '*',
			masonry: {
				columnWidth: '.partner-logo--items',
				gutter: '.partner-logo--gutter',
				isFitWidth: true,
				fitWidth: true
			}
		});

		_self.$isotopeInstance = $initIsotope;

		$partnerElem.style.margin = '0 auto';

		//store filter for each group
		let $filters: any = {}

		$('.filters').on('click', 'a', function(){
			let $this:any = $(this);
			let $buttonGroup: any = $this.parents('.button-group');
			let $filterGroup: any = $buttonGroup.attr('data-filter-group');


			// replace filter group
			// if mainlogo filter group is different, clear subgroup filter
			if ($filterGroup == 'mainlogo' && $filters['mainlogo'] !== $this.attr('data-logo--filter')) {
			// different main filter group
			// so clear sublogo value
			$filters['sublogo'] = '';
			}

			if ($this !== null) {
			$filters[$filterGroup] = $this.attr('data-logo--filter');
			}

			_self.filterPartnerGrid($filters);
		});

		// update total count values on rearranging table
		$initIsotope.on('arrangeComplete', () => {
			_self.partnerLogoDesktopFilter();
		});

		$('.button-group').each(function(i: any, buttonGroup: any){
			let $buttonGroup: any = $( buttonGroup );
			$buttonGroup.on( 'click', 'a', function() {
				$buttonGroup.find('.is-checked').removeClass('is-checked');
				$( this ).addClass('is-checked');
			});
		});


		$('.sort-button-group a').click(function(e: any){
			e.preventDefault();
			$('.sub-group:visible').hide();
			$('#'+$(this).attr('data-showSubGroup')).show();
			$('#'+$(this).attr('data-showSubGroup')).find('a').removeClass('is-checked');
			$('#'+$(this).attr('data-showSubGroup')).find('a').first().addClass('is-checked');
		})
	}

  filterPartnerGrid($filters:any):any {
    let _self = this;

    _self.$filterValue = concatValues($filters);

    _self.$isotopeInstance.arrange({filter: _self.$filterValue});

    // toggle button display if there are any more elements of filter type
    // currently hidden
		let $hiddenElements:any = $('.desktop .spare-partner-elements');
		let itemsToShow:string	= '.partner-logo--items' + _self.$filterValue;
		let partnerElem:any    = document.querySelector('.grid.partner');
		let $shownItemsCount:number		= $(partnerElem).find(_self.$filterValue).length;
		let $hiddenItemsCount:number	= $hiddenElements.find(itemsToShow).length;
		let $showmorePartnersLogoBtn:any = $('.showmore-partners--logo');


		// hide 'show more' button if there are no more hidden items
		if ($hiddenItemsCount) {
			$showmorePartnersLogoBtn.show();
		} else {
			$showmorePartnersLogoBtn.hide();
		}

		// if shown items == 0, trigger show more function by event.click on
		// 'show more' button
		if ($shownItemsCount === 0) {
			$showmorePartnersLogoBtn.trigger('click');
		}

    // flatten object by concatting values
    function concatValues(obj:any) {
      var value = '';
      for ( var prop in obj ) {
        value += obj[ prop ];
      }
      return value;
    }
  }

	partnerIsotopeMob(): any{
		let _self = this;
		let $partnerLogoSel: any = _self.$scope.find('.partner-logo--select');
		let $partnerSubLogoSel: any = _self.$scope.find('.partner-sublogo--select');
		let $filters:any = {};

		$partnerLogoSel.selectize({
	      onChange: function(value:any){
	        $filters['mainlogo'] = value;
	      }
	    });
			$partnerSubLogoSel.selectize({
	      onChange: function(value:any){
	        $filters['sublogo'] = value;
	        _self.filterPartnerGrid($filters);
	      }
	    });

		let partnerLogoSel: any = $partnerLogoSel[0].selectize;
		let partnerSubLogoSel: any = $partnerSubLogoSel[0].selectize;
		let $partnerLogoItems: any = _self.$scope.find('.partner-logo--items');
		let $partnerSubLogodiv:any = _self.$scope.find('.partner-sublogo-mob');
		$partnerSubLogodiv.hide();


		interface filterObject {
			text:string,
			value:string
		}

		let Airlines:Array<filterObject> = [{text: 'All', value: ''}];
		let FinancialServices:Array<filterObject> = [{text: 'All', value: ''}];
		let Accommodation:Array<filterObject> = [{text: 'All', value: ''}];
		let Transportation:Array<filterObject> = [{text: 'All', value: ''}];
		let Shopping:Array<filterObject> = [{text: 'All', value: ''}];
		let Lifestyle:Array<filterObject> = [{text: 'All', value: ''}];

		// populate all filter objects from hidden list element
		_self.$scope.find(".ul-airlines li").each(function(){
			Airlines.push({
			text: 	$(this).attr("data-label"),
			value: 	$(this).attr("data-value")
			});
		});

		_self.$scope.find(".ul-financial-services li").each(function(){
			FinancialServices.push({
			text: 	$(this).attr("data-label"),
			value: 	$(this).attr("data-value")
			});
		});

		_self.$scope.find(".ul-accommodation li").each(function(){
			Accommodation.push({
			text: 	$(this).attr("data-label"),
			value: 	$(this).attr("data-value")
			});
		});

		_self.$scope.find(".ul-transportation li").each(function(){
			Transportation.push({
			text: 	$(this).attr("data-label"),
			value: 	$(this).attr("data-value")
			});
		});

		_self.$scope.find(".ul-shopping li").each(function(){
			Shopping.push({
			text: 	$(this).attr("data-label"),
			value: 	$(this).attr("data-value")
			});
		});

		_self.$scope.find(".ul-lifestyle li").each(function(){
			Lifestyle.push({
			text: 	$(this).attr("data-label"),
			value: 	$(this).attr("data-value")
			});
		});

		partnerLogoSel.on('change', function(value: any) {
			if(value == '.all') {
				partnerSubLogoSel.clearOptions();
				partnerSubLogoSel.refreshOptions();
				$partnerSubLogodiv.hide();
				$filters['mainlogo'] = '';
				$filters['sublogo'] = '';
				_self.filterPartnerGrid($filters);				
			} else if(value == '.airlines') {
				$partnerSubLogodiv.show();
				partnerSubLogoSel.clear();
				partnerSubLogoSel.clearOptions();				
				partnerSubLogoSel.renderCache = {};
				partnerSubLogoSel.load(function (callback: any) {
					callback(Airlines);
				});				
				//partnerSubLogoSel.refreshOptions();
				partnerSubLogoSel.setValue('', false);
			}  else if(value == '.financial-services') {
				$partnerSubLogodiv.show();
				partnerSubLogoSel.clear();
				partnerSubLogoSel.clearOptions();
				partnerSubLogoSel.renderCache = {};
				partnerSubLogoSel.load(function (callback: any) {
					callback(FinancialServices);
				});				
				//partnerSubLogoSel.refreshOptions();
				partnerSubLogoSel.setValue('', false);
			}  else if(value == '.accommodation') {
				$partnerSubLogodiv.show();
				partnerSubLogoSel.clear();
				partnerSubLogoSel.clearOptions();
				partnerSubLogoSel.renderCache = {};
				partnerSubLogoSel.load(function (callback: any) {
					callback(Accommodation);
				});				
				//partnerSubLogoSel.refreshOptions();
				partnerSubLogoSel.setValue('', false);
			}  else if(value == '.transportation') {
				$partnerSubLogodiv.show();
				partnerSubLogoSel.clear();
				partnerSubLogoSel.clearOptions();
				partnerSubLogoSel.renderCache = {};
				partnerSubLogoSel.load(function (callback: any) {
					callback(Transportation);
				});				
				//partnerSubLogoSel.refreshOptions();
				partnerSubLogoSel.setValue('', false);
			}  else if(value == '.shopping') {
				$partnerSubLogodiv.show();
				partnerSubLogoSel.clear();
				partnerSubLogoSel.clearOptions();
				partnerSubLogoSel.renderCache = {};
				partnerSubLogoSel.load(function (callback: any) {
					callback(Shopping);
				});					
				//partnerSubLogoSel.refreshOptions();
				partnerSubLogoSel.setValue('', false);
			}  else if(value == '.lifestyle') {
				$partnerSubLogodiv.show();
				partnerSubLogoSel.clear();
				partnerSubLogoSel.clearOptions();
				partnerSubLogoSel.renderCache = {};
				partnerSubLogoSel.load(function (callback: any) {
					callback(Lifestyle);
				});		
				//partnerSubLogoSel.refreshOptions();
				partnerSubLogoSel.setValue('', false);
			}
		});
	}

	partnerLogoDesktopFilter():any {
		let _self = this;
		let $showmorePartnersLogoBtn: any = $('.showmore-partners--logo');
		let $totalPartnersLogo: any       = $('.desktop .partner-logo--items').length;
		let $limitPartnersLogo: any       = $('.partner-logo--grid.desktop').attr('data-item--showonload');
		let $showLogoItem:any             = $('.show-partnerlogo--items .showing');
		let $totalPartnersItem: any       = $('.show-partnerlogo--items .total-destinations');

		let $visiblePartners: any = $('.desktop .partner-logo--items:visible').length;

		$showLogoItem.html($visiblePartners);
		$totalPartnersItem.html($totalPartnersLogo);

		// hide show more button if all partner items are visible
		if ($visiblePartners == $totalPartnersLogo) {
			$showmorePartnersLogoBtn.fadeOut();
		}
	}

	partnerDesktopShowMoreBtn():any {
		let _self = this;
		let $partnerElem: any             = document.querySelector('.grid.partner');
		let $showmorePartnersLogoBtn: any = $('.showmore-partners--logo');
		let $totalPartnersLogo: any       = $('.desktop .partner-logo--items').length;
		let $showLogoItem:any             = $('.show-partnerlogo--items .showing');
		let $totalPartnersItem: any       = $('.show-partnerlogo--items .total-destinations');
		let $limitPartnersLogo: any       = $('.partner-logo--grid.desktop').attr('data-item--showonload');
		let $hiddenElements:any           = $('.desktop .spare-partner-elements');
		let $nextShowItems: any           = $('.partner-logo--grid.desktop').attr('data-item--showeachclick');

		// $(".desktop .partner-logo--items:lt("+$limitPartnersLogo+")").show();

		$showmorePartnersLogoBtn.on('click', (e:any) => {
			e.preventDefault();

			let itemsToShow = '.partner-logo--items' + _self.$filterValue;
			let $hiddenItems = $hiddenElements.find(itemsToShow);
			let $next4toShow:any = $hiddenItems.slice(0, $nextShowItems).toArray();
			let $remainderCount = $hiddenItems.length - 4;

			$next4toShow.map((el:any, index:number) => {
				$partnerElem.append(el);
			// el.remove();
			_self.$isotopeInstance.appended(el);
			});

			if ($remainderCount < 1) {
				$showmorePartnersLogoBtn.fadeOut();
			}
			_self.$isotopeInstance.arrange({filter: _self.$filterValue});
		});
	}

}

let scope:Element = document.querySelector('.partner-offer--logofilter');
if (scope){
	try {
	let partnerlogofilter = new partnerLogoFilter();
	partnerlogofilter.partnerDesktopShowMoreBtn();
	partnerlogofilter.partnerIsotope();
	partnerlogofilter.partnerIsotopeMob();
	partnerlogofilter.partnerLogoDesktopFilter();
	$(document).ready(function() {
		$(".is-checked")[0].click();
	});
	} catch(e) {console.error(e);}
}
